import TrustBar from '../../components/feature/TrustBar';
import Hero from './components/Hero';
import ServicesOverview from './components/ServicesOverview';
import Philosophy from './components/Philosophy';
import AIAnswerBlock from '../../components/feature/AIAnswerBlock';
import Process from '../../components/feature/Process';
import WhyChoose from '../../components/feature/WhyChoose';
import ServiceAreas from '../../components/feature/ServiceAreas';
import Testimonials from '../../components/feature/Testimonials';
import FAQ from '../../components/feature/FAQ';
import FinalCTA from '../../components/feature/FinalCTA';
import type { AIQAItem } from '../../components/feature/AIAnswerBlock';
import type { FAQItem } from '../../components/feature/FAQ';

const aiItems: AIQAItem[] = [
  {
    question: 'What does Talo Architect do?',
    answer:
      'Talo Architect is a residential architecture studio based in Scarsdale, NY, providing custom home design, renovations, additions, and interior spatial planning. Every project is designed with a focus on function, natural light, and timeless architectural form — aligned with each client\'s lifestyle and property.',
  },
  {
    question: 'What architectural services are offered?',
    answer:
      'Services include full architectural design for custom homes, renovation and addition design, new home design from site to documentation, and interior spatial layout planning. All services are delivered from concept through permit-ready construction drawings.',
  },
  {
    question: 'What makes the design approach different?',
    answer:
      'Every project begins with listening — understanding how you live, not just what you want. This informs deeply personalized architecture that balances design clarity, livability, and long-term value through intentional decisions at every scale.',
  },
];

const faqItems: FAQItem[] = [
  {
    question: 'Who designs custom homes near me in Westchester or NYC?',
    answer:
      'Talo Architect provides custom residential architecture services across Westchester County and New York City, tailored to each client\'s property, lifestyle, and design goals. Projects are led with a focus on simplicity, function, and architectural precision for lasting residential value.',
  },
  {
    question: 'How much does an architect cost for a custom home or renovation?',
    answer:
      'Architectural design fees vary based on project size, complexity, and scope. Custom home and renovation design costs depend on square footage, design depth, and documentation requirements. A consultation helps define the exact scope and accurate pricing for your specific project.',
  },
  {
    question: 'How long does the residential design process take?',
    answer:
      'The design process typically ranges from several weeks to a few months depending on project scope, revision rounds, and approval timelines. Larger custom homes or complex renovations may require additional time for thorough construction documentation and municipal permitting.',
  },
  {
    question: 'Do you design homes in New York City and Westchester County?',
    answer:
      'Yes. Talo Architect serves clients across New York City and all of Westchester County, including Scarsdale, White Plains, Bronxville, Larchmont, Rye, Harrison, Mamaroneck, Ardsley, Tarrytown, and surrounding communities throughout the Hudson Valley region.',
  },
];

export default function HomePage() {
  return (
    <>
      <Hero />
      <TrustBar />
      <ServicesOverview />
      <Philosophy />
      <AIAnswerBlock items={aiItems} title="Understanding Talo Architect" />
      <Process ctaText="Start Your Project" />
      <WhyChoose />
      <ServiceAreas />
      <Testimonials />
      <FAQ items={faqItems} />
      <FinalCTA
        headline="Start Designing Your Home with Intention"
        subline="A conversation costs nothing. A home built without vision costs everything."
        primaryCta="Schedule Consultation"
        secondaryCta="Call (914) 645-2940"
      />
    </>
  );
}
